export type CouponCodeProps = {
  children: string
}

export const CouponCode = ({ children }: CouponCodeProps) => {
  return <code className="text-np-green font-medium capitalize">{children}</code>
}
